import { arrayAny } from "../../utils/arrayUtils";
import { TenantTiles } from "./tenant-tiles";
import { TenantListView } from './tenant-list-view';

import './tenant-list-view-style.css';

export const TenantsContainer = ({ tenants, displayType }) => {

    return (
        <>
            {displayType === 'grid' && arrayAny(tenants) && (

                <div className={'pos-customer'} >
                    <div className="pos-content">
                        <div className="pos-content-container" options={{ suppressScrollX: true }}>
                            <div className="product-row">
                                <TenantTiles tenants={tenants} />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {displayType === 'list' && arrayAny(tenants) && (
                <div className="tenant-list">
                    {tenants.map(tenant => (
                        <TenantListView key={tenant.id} tenant={tenant} />
                    ))}
                </div>
            )}
        </>
    );
};